module.exports = requirejs;


//////////////////
// WEBPACK FOOTER
// external "requirejs"
// module id = 24
// module chunks = 0